var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKabelOnlineServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 71,
    viewBox: "0 0 181 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18389 8.0068C2.9631 7.36178 1.45057 7.82854 0.805559 9.04933C0.160546 10.2701 0.627304 11.7827 1.84809 12.4277L4.18389 8.0068ZM30.3739 24.672L29.206 26.8824C29.9913 27.2974 30.9379 27.2645 31.6925 26.796L30.3739 24.672ZM64.91 3.23145L66.1569 1.06458C65.359 0.605481 64.3734 0.621955 63.5914 1.10746L64.91 3.23145ZM176.933 70.5774C178.13 71.2661 179.658 70.8542 180.347 69.6574C181.036 68.4607 180.624 66.9323 179.427 66.2437L176.933 70.5774ZM1.84809 12.4277L29.206 26.8824L31.5418 22.4616L4.18389 8.0068L1.84809 12.4277ZM31.6925 26.796L66.2286 5.35543L63.5914 1.10746L29.0553 22.548L31.6925 26.796ZM63.6631 5.39831L176.933 70.5774L179.427 66.2437L66.1569 1.06458L63.6631 5.39831Z",
    fill: "#b4005f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKabelOnlineServices);
export default __webpack_public_path__ + "static/media/Kabel-Online-Services.75865a057c75e2c086914c51ba6762a4.svg";
export { ForwardRef as ReactComponent };